import { z } from 'zod';

/** `POST /api/billing/checkout` body (M6 Task 3) — `free` is deliberately excluded: there is
 * no Polar product for it (absence of subscription = free), so it can never be a checkout
 * target. */
export const checkoutSchema = z.object({
  plan: z.enum(['starter', 'growth']),
});

export type CheckoutInput = z.infer<typeof checkoutSchema>;
